module.exports = {
    "dismiss": `Elutas\xedt\xe1s`
};


//# sourceMappingURL=hu-HU.main.js.map
